import { render, staticRenderFns } from "./ContactsContent.vue?vue&type=template&id=6c3716f9&"
import script from "./ContactsContent.vue?vue&type=script&lang=js&"
export * from "./ContactsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports